import { PropertyType } from 'esa-ui-library/lib/types';
import { OptionType, TableHeaderType } from '../../../common';
import { reportConstants } from '../../constants/reports';
import { isEmpty } from 'lodash';

export const filterFieldsByEnv = (fields: TableHeaderType[]): TableHeaderType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter((f) => f.label !== reportConstants.REPORT_PGDA_831);
	}

	return result;
};

export const filterSearchOptionsByEnv = (fields: OptionType[]): OptionType[] => {
	let result = [...fields];
	if (!process.env.REACT_APP_SITE_TITLE?.includes('Italy')) {
		result = result.filter((f) => f.value !== 'aams_game_ids');
	}

	return result;
};

export const getErrorMessage = (field: string): string => `${field} is required`;

export const validateForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};
	if (!form.game_name) {
		errors.game_name = getErrorMessage('Game name');
	}

	return !isEmpty(errors) ? errors : null;
};
